export default {
  setCurrentQuestion (state, payload) {
    state.currentQuestion = payload
  },
  setAnswers (state, payload) {
    state.answers = payload
  },
  setQuestionFlowData (state, payload) {
    state.questionFlowData = payload
  },
  setOrgGuid (state, payload) {
    state.orgGuid = payload
  },
  setOrgType (state, payload) {
    const types = ['company', 'region', 'branch']
    const orgType = types.find(type => payload[type]) || null
    state.orgType = orgType
  },
  setSettings (state, payload) {
    state.settings = payload
  }
}
